module.exports = __webpack_public_path__ + "img/def-banner-2.2415f8d2.jpg";